// 生产环境配置
export default {
  // API基础URL - 根据当前域名动态设置
  baseURL: window.location.origin + '/management/',
  
  // 环境标识
  env: 'production',
  
  // 应用标题
  title: '继教管理系统',
  
  // 请求超时（毫秒）
  timeout: 30000,  // 10秒
  
  // 是否启用日志
  enableLog: false,
}

